// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see BorrowUpdateActivateEvent
 */
export var BorrowUpdateActivate = function (_a) {
    var loanToken = _a.loanToken;
    return ({
        name: "Borrow Update Activate",
        parameters: {
            cdf_entity: "Borrow",
            cdf_action: "Update",
            loan_token: loanToken !== undefined && loanToken !== null ? loanToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BorrowUpdateQualifyEvent
 */
export var BorrowUpdateQualify = function (_a) {
    var isEligible = _a.isEligible;
    return ({
        name: "Borrow Update Qualify",
        parameters: {
            cdf_entity: "Borrow",
            cdf_action: "Update",
            is_eligible: isEligible !== undefined && isEligible !== null ? isEligible.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
